/* eslint-disable import/prefer-default-export */
import { BCBS_NORTH_CAROLINA } from 'utils/constants';

const referringClinicConfig = {
  [BCBS_NORTH_CAROLINA]: {
    options: [
      { name: 'Olive Chapel Road - Apex', city: 'Apex' },
      { name: 'Crescent Commons Drive | Kildaire Farm - Cary', city: 'Cary' },
      { name: 'Midtown | Kings Drive - Midtown Charlotte', city: 'Charlotte' },
      { name: 'Franklin Street - Chapel Hill', city: 'Chapel Hill' },
      { name: 'Briar Chapel | Veranda - South Chapel Hill', city: 'Chapel Hill' },
      { name: 'Southpark | Fairview Road', city: 'Charlotte' },
      { name: 'NC Highway 42 West - Clayton', city: 'Clayton' },
      { name: 'Martin Luther King Jr. Parkway - Durham', city: 'Durham' },
      { name: 'Attain Street - Fuquay Varina', city: 'Fuquay-Varina' },
      { name: 'Main Street Square - Holly Springs', city: 'Holly Springs' },
      { name: 'Hinton Oaks Boulevard - Knightdale', city: 'Knightdale' },
      { name: 'Matthews | Sam Newell Road - Matthews', city: 'Matthews' },
      { name: 'Timber Drive - Garner', city: 'Garner' },
      { name: 'Brier Creek Parkway - Northwest Raleigh', city: 'Raleigh' },
      { name: 'Avance Psychiatry (now Centers of Excellence)', city: 'Raleigh' },
      { name: 'Oberlin Road - Central Raleigh', city: 'Raleigh' },
      { name: 'Strickland Road - North Raleigh', city: 'Raleigh' },
      { name: 'Perry Creek Road - Northeast Raleigh', city: 'Raleigh' },
      { name: 'South Main Street - Wake Forest', city: 'Wake Forest' },
      { name: 'Avance Psychiatry Charlotte', city: 'Charlotte' },
      { name: 'Avance Behavioral Health Centers of Excellence', city: 'Raleigh' },
      { name: 'Avance Neurology', city: 'Raleigh' },
      { name: 'Preston | NW Cary Parkway', city: 'Cary' },
      { name: 'Capital Blvd | Stadium Drive - North Wake Forest', city: 'Wake Forest' },
      { name: 'Midtown Raleigh | Wake Forest Road', city: 'Raleigh' },
      { name: 'Rea Farms | Providence Road', city: 'Charlotte' },
      { name: 'Avance Psychiatry and Pain Management', city: 'Chapel Hill' },
      { name: 'Davidson Family Medicine', city: 'Davidson' },
      { name: 'Broad Street', city: 'Durham' },
      { name: 'RTP', city: 'Durham' },
      { name: 'Waxhaw', city: 'Waxhaw' },
      { name: 'Avance Care Wilmington', city: 'Wilmington' },
      { name: 'Avance Care Pediatrics | Southern Village', city: 'Chapel Hill' },
      { name: 'Avance Care Southeast Cary', city: 'Cary' },
      { name: 'FastMed Clayton Primary Care', city: 'Clayton' },
      { name: 'FastMed Garner – Cleveland Primary Care', city: 'Garner' },
      { name: 'FastMed Asheville - Hendersonville Rd Primary Care', city: 'Asheville' },
      { name: 'FastMed Sanford Primary Care', city: 'Sanford' },
      { name: 'FastMed Fayetteville – Francam Dr Primary Care', city: 'Fayetteville' },
      { name: 'FastMed Burlington Primary Care', city: 'Burlington' },
      { name: 'FastMed Durham Primary Care', city: 'Durham' },
      { name: 'FastMed Greenville Primary Care', city: 'Greenville' },
      { name: 'FastMed Raleigh - Downtown Primary Care', city: 'Raleigh' },
      { name: 'FastMed Roanoke Rapids Primary Care', city: 'Roanoke' },
      { name: 'FastMed Kinston Primary Care', city: 'Kinston' },
      { name: 'FastMed - Goldsboro Primary Care', city: 'Goldsboro' },
    ],
    groupBy: 'city',
    includeNoneOption: true,
  },
};

export function getReferringClinicConfig(client) {
  return referringClinicConfig[client] || {};
}
